module.exports = __webpack_public_path__ + "img/tips.bfd20bb6.png";